
const stationsStore = {
    state: {
        concepts: {
          currentPosition: 0,
          scrollToConceptId: '',
          scrollNavEvent: null,
        },
        right: {
          contentHeight: '200px',
        },
        grid: {
          leftOpen: false,
          rightOpen: true,
        }
    },
    getters: {
    },
    actions: {
      scrollToConcept(context, id){
        context.commit('setScrollToConceptId', { id });
      },
      addToConceptsScroll(context, e){
        context.commit('setScrollNavEvent', { e });
      },
      openLeft(context){
        context.commit('setLeft', { newState: true });
      },
      closeLeft(context){
        context.commit('setLeft', { newState: false });
      },
      toggleLeft(context){
        let newState = !context.state.grid.leftOpen;
        context.commit('setLeft', { newState: newState });
      },
      openRight(context){
        context.commit('setRight', { newState: true });
      },
      closeRight(context){
        context.commit('setRight', { newState: false });
      },
      closeLeftAndRight(context){
        context.commit('setLeft', { newState: false });
        context.commit('setRight', { newState: false });
      },
    },
    mutations: {
      setScrollToConceptId(state, { id }){
        state.concepts.scrollToConceptId = id;
      },
      setConceptsCurrentPosition(state, { pos }){
        state.concepts.currentPosition = pos;
      },
      setScrollNavEvent(state, { e }){
        state.concepts.scrollNavEvent = e;
      },
      setRightContentHeight(state, { height }) {
        state.right.contentHeight = height + 'px';
      },
      setLeft(state, { newState }){
        state.grid.leftOpen = newState;
      },
      setRight(state, { newState }){
        state.grid.rightOpen = newState;
      },
    },
}
export default stationsStore;
